import { PrimaryMetroRegions } from '@cian/chats-api/lib/browser-entry';

import { IOfferGeo } from '../../types/offer';

export function isPrimaryMetroRegion(geo?: IOfferGeo): boolean {
  if (geo && geo.undergrounds && geo.undergrounds.length && geo.address && geo.address.length) {
    return PrimaryMetroRegions.includes(geo.address[0].id);
  }

  return false;
}
